import React from "react";
import { Row, Col } from "antd";
import FlowCard from "../../../../../../CommonComponents/FlowCard/FlowCard";
import { Heading, EditFlowTable } from "../styles";
import { DataHeading, DataValue } from "../../../../../../CommonComponents/commonStyles";
import { replaceSelect } from "../../../../../../utils/replacer";
const fromColumns = [
  {
    title: () => {
      return <DataValue>Investment options</DataValue>;
    },
    dataIndex: "pool",
    key: "Investment Option",
    render: record => {
      return <DataHeading>{replaceSelect(record)}</DataHeading>;
    },
  },
  {
    title: () => {
      return <DataValue>Dollars</DataValue>;
    },
    dataIndex: "value",
    key: "Dollars",
    render: text => (
      <DataHeading>
        {"$ " +
          Number(text).toLocaleString(undefined, {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
          })}
      </DataHeading>
    )
  }
];

const isPrint = () => window.matchMedia('print');

export default function ViewAndEditFromTable(props) {
  return (
    <Row>
      <Col lg={12} md={12} sm={12} xs={isPrint() ? 24 : 0}>
        <EditFlowTable
          dataSource={props.dataSource.exchangeFrom}
          columns={fromColumns}
          pagination={false}
        />
      </Col>
    </Row>
  );
}
